module.exports = __webpack_public_path__ + "img/Saryah-SignIn.8036ac36.png";